import {
  SET_CONVERSATIONS,
  SET_CURRENT_CONVERSATION,
  SET_PAGINATION_CONVERSATIONS,
  SET_DATA_CURRENT_CONVERSATION,
  SET_MESSAGES_HISTORY,
  SET_PAGINATION_MESSAGES_HISTORY,
  SET_BABY_ID,
  RESET_CHAT,
  SET_IS_SCROLL_TO_BOTTOM_LIST_CHAT,
  SET_LOADING_SCREEN_CHAT,
} from 'store/types/chat';

export const setConversations = (conversations) => {
  return {
    type: SET_CONVERSATIONS,
    payload: conversations,
  };
};

export const setCurrentConversation = (currentConversation) => {
  return {
    type: SET_CURRENT_CONVERSATION,
    payload: currentConversation,
  };
};

export const setPaginationConversations = (paginationConversations) => {
  return {
    type: SET_PAGINATION_CONVERSATIONS,
    payload: paginationConversations,
  };
};

export const setDataCurrentConversation = (dataCurrentConversation) => {
  return {
    type: SET_DATA_CURRENT_CONVERSATION,
    payload: dataCurrentConversation,
  };
};

export const setMessagesHistory = (messagesHistory) => {
  return {
    type: SET_MESSAGES_HISTORY,
    payload: messagesHistory,
  };
};

export const setPaginationMessagesHistory = (paginationMessagesHistory) => {
  return {
    type: SET_PAGINATION_MESSAGES_HISTORY,
    payload: paginationMessagesHistory,
  };
};

export const setBabyId = (babyId) => {
  return {
    type: SET_BABY_ID,
    payload: babyId,
  };
};

export const resetChat = () => {
  return {
    type: RESET_CHAT,
  };
};

export const setIsScrollToBottomListChat = (isScrollToBottomListChat) => {
  return {
    type: SET_IS_SCROLL_TO_BOTTOM_LIST_CHAT,
    payload: isScrollToBottomListChat,
  };
};

export const setLoadingScreenChat = (loadingScreenChat) => {
  return {
    type: SET_LOADING_SCREEN_CHAT,
    payload: loadingScreenChat,
  };
};
